import { render, staticRenderFns } from "./DataListTeams_rejete.vue?vue&type=template&id=82d87adc&scoped=true&"
import script from "./DataListTeams_rejete.vue?vue&type=script&lang=js&"
export * from "./DataListTeams_rejete.vue?vue&type=script&lang=js&"
import style0 from "./DataListTeams_rejete.vue?vue&type=style&index=0&id=82d87adc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d87adc",
  null
  
)

export default component.exports